import { selectRelatedObjectsByObjectName } from '../../../reducers/global/globalReducer';
import { selectRollupsForTable } from '../../../reducers/global/rollupReducers';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { findSweepElementsRelatedToObject } from './findSweepElementsRelatedToObject';
import { useGetDeployedVersions } from './useGetDeployedVersions';
import {
  createConfigurationItemFromAutomation,
  createConfigurationItemsFromRelatedObjectsData,
} from '../helpers';
import flatten from 'lodash/flatten';
import { selectAccountUsers } from '../../../reducers/accountUsersReducer';
import { ConfigurationItem } from '../dependencies/DependenciesTypes';
import { RelatedObjectData } from '../../parser/ParserTypes';

export const useGetRelatedObjects = (crmOrgId: string, objectName: string) => {
  const relatedObjects = useSelector(selectRelatedObjectsByObjectName(crmOrgId))?.[
    objectName ?? ''
  ];
  const rollups = useSelector(selectRollupsForTable);
  const deployedVersions = useGetDeployedVersions(crmOrgId);
  const users = useSelector(selectAccountUsers);

  const sweepRelatedObjects = useMemo(() => {
    if (!objectName) {
      return [];
    }
    return flatten([
      ...findSweepElementsRelatedToObject(deployedVersions.automations, objectName),
      ...findSweepElementsRelatedToObject(deployedVersions.alerts, objectName),
      ...findSweepElementsRelatedToObject(deployedVersions.dedup, objectName),
      ...findSweepElementsRelatedToObject(deployedVersions.matching, objectName),
      ...findSweepElementsRelatedToObject(deployedVersions.assignments, objectName),
      ...findSweepElementsRelatedToObject(deployedVersions.scheduledAssignments, objectName),
    ]).map(
      (automation) => createConfigurationItemFromAutomation(automation, users) as ConfigurationItem,
    );
  }, [deployedVersions, objectName, users]);

  const relatedObjectsStructure = useMemo(() => {
    return [
      ...createConfigurationItemsFromRelatedObjectsData(
        relatedObjects ?? ({} as RelatedObjectData),
        rollups,
      ),
      ...sweepRelatedObjects,
    ];
  }, [relatedObjects, rollups, sweepRelatedObjects]);

  return relatedObjectsStructure;
};
